import { constants, typographyStyles } from "@newsela/angelou";
import { PropTypes } from "prop-types";

export { constants, Banner } from "@newsela/angelou";
export { default as SvgComponent } from "./SvgComponent";
export { default as customConfigFrom } from "./customConfigFrom";
export { default as customCssForFrom } from "./customCssForFrom.style";

export const core700 = constants.colors.ui.core[700];

const fontNoto = typographyStyles.fontFamily.noto;

export const cssForBase = {
  root: {
    padding: "26px 16px",
    margin: "32px 36px 0px 36px",
    borderRadius: "12px",
  },
  title: [{ ...fontNoto }],
  Icon: {
    root: [{ "--banner-visual-size-lg": "88px" }],
  },
};

export const propTypes = {
  title: PropTypes.string.required,
  body: PropTypes.string.required,
  __cssFor: PropTypes.object,
  whiteBgColor: PropTypes.bool,
  cta: PropTypes.node,
};
